export default "__VITE_ASSET__5A$TqU$q__"